











































































































































import { Component, Vue, Watch } from "vue-property-decorator"
import { AutoPlayIo } from "@/utils/base"
import { videoSortType } from "./extra"
import { MBbsContent } from "@/api/api"

enum sortType {
  create = "time.create:-1",
  reply = "time.reply:-1"
}

@Component({
  name: "ContentList",
  components: {
    CardItem: () => import("@/components/bbsCardItem/bbsCardItem.vue"),
    LoadMore: () => import("@/components/loadMore/loadMore.vue"),
    NoMoreData: () => import("@/components/noMoreData/noMore.vue"),
    Img: () => import("@/components/image/image.vue"),
    Empty: () => import("@/components/empty/empty.vue"),
    LoadMoreBtn: () => import("@/components/LoadMoreBtn/LoadMoreBtn.vue"),
    JinghuaList: () => import("./JinghuaList.vue"),
    QuesList: () => import("./QuesList.vue"),
    VideoCard: () => import("./VideoCard.vue"),
    VideoList: () => import("./VideoList.vue")
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name !== "communityArticleThread" &&
      to.name !== "article" &&
      to.name !== "question" &&
      to.name !== "video"
    ) {
      this.reset()
    }
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name === "bbsList") {
        vm["reset"]()
      }
    })
  }
})
export default class Content extends Vue {
  get bbs() {
    return this.$store.state.bbs.bbs
  }

  get content() {
    return this.$root.$tstore.modules.content.getters.content
  }
  loading = false
  keyword = ""
  nextList = []

  reset() {
    this.$root.$tstore.modules.content.mutations.RESET_CONTENT()
    this.$root.$tstore.modules.content.mutations.RESET_JINGHUA()
    this.$root.$tstore.modules.content.mutations.RESET_VIDEO()
    this.$root.$tstore.modules.content.mutations.RESET_QUES()
    this.nextList = []
    this.type = 0
  }

  /** SSR 以及初次渲染 */
  serverPrefetch() {
    return this.fetchData()
  }

  async activated() {
    if (this.content.data.length === 0) {
      await this.fetchData()
    }
    if (this.nextList.length === 0) {
      this.$root.$tstore.modules.content.mutations.SET_CONTENT({
        page: this.content.page + 1
      })
      this.getContentList()
    }
    if (!this.$isServer) {
      this.autoPlayIo = new AutoPlayIo({ classTag: "video-card" })
      this.autoPlayIo.addIo()
    }
  }

  // 请求数据
  async fetchData() {
    this.loading = true
    return this.$root.$tstore.modules.content.actions
      .FETCH_CONTENT({
        id: this.$route.params.bbs_id
      })
      .finally(() => {
        this.loading = false
        this.$loading(false)
      })
  }

  /** 客户端请求数据 */
  async getContentList() {
    const res = await this.$root.$tstore.getters.api.content.list(
      this.$route.params.bbs_id,
      {
        sort: this.sort,
        type: "community_article|video|question",
        page: this.content.page,
        page_size: this.content.page_size
      }
    )
    if (res.data.length === 0) {
      this.$root.$tstore.modules.content.mutations.SET_CONTENT({
        finished: true
      })
      this.nextList = []
    } else {
      this.nextList = res.data
    }
  }
  handleLoadMore() {
    this.$root.$tstore.modules.content.mutations.SET_CONTENT({
      data: this.content.data.concat(this.nextList),
      page: this.content.page + 1
    })
    this.getContentList()
  }

  type = 0 //  0 全部  1 精华  2 提问  3 视频
  sortType = sortType
  sort = sortType.reply

  @Watch("sort")
  async onSort(sort) {
    if (this.type === 2) return
    if (sort) {
      this.$root.$tstore.modules.content.mutations.RESET_CONTENT()
      this.nextList = []
      this.loading = true
      await this.getContentList()
      this.$root.$tstore.modules.content.mutations.SET_CONTENT({
        data: this.content.data.concat(this.nextList),
        page: this.content.page + 1
      })
      this.loading = false
      await this.getContentList()
    }
  }

  onType(c) {
    if (c === 2) {
      this.sort = sortType.create
    }
  }

  videoSortType = videoSortType
  videoSort = videoSortType.recommend

  createUrl(item: MBbsContent.IContent) {
    switch (item.type) {
      case "community_article":
        return `/bbs/thread-${item._seq || item._id}`
      case "question":
        return `/bbs/question-${item._seq || item._id}`
      case "video":
        return `/bbs/video-${item._seq || item._id}`
    }
    return ""
  }
  // 搜索
  handleSearch() {
    if (this.keyword.length > 0 && this.keyword) {
      this.$router.push(
        `/bbs/${this.$route.params.bbs_id}/search/${this.keyword}`
      )
    }
  }
  // 清除内容搜索框
  handleClear() {
    this.keyword = ""
  }

  autoPlayIo = null
  destroyed() {
    if (this.autoPlayIo) {
      this.autoPlayIo.remove()
    }
  }
}
